import axios from "axios"; // 引入axios
// import { ElLoading } from 'element-plus'
import Cookies from "js-cookie";
import Vue from "vue";
import router from "../router";


//web接口
const webapi = 'http://mfapi.818long.com/webapi/' // 正式
// const webapi = 'http://109.244.44.238:8000/webapi/' // 本地

// 创建基础 cwsl 实例
const cwslapi = axios.create({
  baseURL: "http://mfapi.818long.com/shopapi/", //线上地址

  // baseURL: "http://109.244.44.238:8000/shopapi/", //本地地址
  withCredentials: true,
  timeout: 5000,
});

// http request 拦截器  cwslapi 实例
cwslapi.interceptors.request.use(
  (config) => {
    let cwsl_token = Cookies.get("cwsl_token");
    let cwsl_userId = Cookies.get("cwsl_userId");

    config.headers = {
      "Content-Type": "application/json",
      token: cwsl_token,
      userId: cwsl_userId,
      ...config.headers,
    };
    return config;
  },
  (error) => {
    Vue.prototype.$message.error("当前系统开了小差，请重试！");
    // ElMessage({
    //   showClose: true,
    //   message: error,
    //   type: "error",
    // });
    return error;
  }
);

// http response 拦截器 ebapi 实例
cwslapi.interceptors.response.use(
  (response) => {
    if (response.headers["new-token"]) {
      //   userStore.setToken(response.headers['new-token'])
    }
    if (response.data.code === 0 || response.headers.success === "true") {
      if (response.headers.msg) {
        response.data.msg = decodeURI(response.headers.msg);
      }
      return response.data;
    } else {
      // ElMessage({
      //   showClose: true,
      //   message: response.data.msg || decodeURI(response.headers.msg),
      //   type: 'error'
      // })
      return response.data.msg ? response.data : response;
    }
  },
  (error) => {
    // console.log(error.response, "error");

    if (!error.response) {
      Vue.prototype.$alert(
        `
        <p>检测到请求错误</p>
        <p>${error}</p>
        `,
        "请求报错",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "稍后重试",
          callback: (action) => {
            this.$message({
              type: "info",
              message: `action: ${action}`,
            });
          },
        }
      );
      return;
    }

    switch (error.response.status) {
      case 500:
        Vue.prototype.$alert(
          `
        <p>检测到接口错误${error}</p>
        <p>错误码<span style="color:red"> 500 </span>：此类错误内容常见于后台panic，请先查看后台日志，如果影响您正常使用可强制登出清理缓存</p>
        `,
          "接口报错",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "我知道了",
            callback: (action) => {
              this.$message({
                type: "info",
                message: `action: ${action}`,
              });
            },
          }
        );
        break;
      case 404:
        Vue.prototype.$alert(
          `
          <p>检测到接口错误${error}</p>
          <p>错误码<span style="color:red"> 404 </span>：此类错误多为接口未注册（或未重启）或者请求路径（方法）与api路径（方法）不符--如果为自动化代码请检查是否存在空格</p>
          `,
          "接口报错",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "我知道了",
            callback: (action) => {
              this.$message({
                type: "info",
                message: `action: ${action}`,
              });
            },
          }
        );
        break;
      case 401:
        Vue.prototype.$alert(
          `
          <p>无效的令牌</p>
          <p>错误码:<span style="color:red"> 401 </span>错误信息:${error}</p>
          `,
          "身份信息",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "我知道了",
            callback: (action) => {
              this.$message({
                type: "info",
                message: `action: ${action}`,
              });
            },
          }
        );
        break;

      case 402:
        Vue.prototype.$alert(
          `
          <p>账号已失效，请重新登录，点击后返回首页</p>
          `,
          "提示",
          {
            dangerouslyUseHTMLString: true,
            showClose: false,
            confirmButtonText: "我知道了",
            callback: (action) => {
              Cookies.remove("cwsl_token");
              Cookies.remove("cwsl_userId");
              Cookies.remove("cwsl_token", { domain: ".818long.com" });
              Cookies.remove("cwsl_userId", { domain: ".818long.com" });
              localStorage.removeItem("userInfo");
              router.replace('/')
              // location.reload();
            },
          }
        );

        break;
    }

    return error;
  }
);

export { cwslapi,webapi };
